
import { defineComponent } from 'vue';
import { AppCard, AppSimpleTable, AppButton } from '@/components';
import { usePromotionItemDetail } from '@/modules/promotion/item/model/detail';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { Options } from '@/modules/promotion/item/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.ITEM.DETAIL,
    components: { AppCard, AppSimpleTable, AppButton },
    setup() {
        const { model, actions } = usePromotionItemDetail();

        return { model, Options, renderOption, formatDate, actions, ROUTE_NAME_PROMOTION };
    }
});
